import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CbFormsModule } from '../forms/forms.module';
import { ToggleListFilterMenuComponent } from './toggle-list-filter-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';


@NgModule({
    declarations: [ToggleListFilterMenuComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatTooltipModule,
        MatSlideToggleModule,
        CbFormsModule
    ],
    exports: [ToggleListFilterMenuComponent]
})

export class CbToggleListFilterMenuModule { }
